import React, { FC } from 'react';

import { AvailabilityInput } from './AvailabilityInput';

const SchedulePermanent: FC = (): React.ReactElement => {
  return (
    <div className="flex flex-col gap-9 w-full">
      <AvailabilityInput id="availability" className="w-[140px]" />
      <p className="text-sm text-zinc-500">
        Permanent events won't have an end date
      </p>
    </div>
  );
};

export { SchedulePermanent };
